import {HashTabId} from 'app/components/tabNavigation/store/types';
import {TabNavigationConfig} from 'interfaces/common/components/general/tab/tabNavigationConfig';

export function getSelectedIndexFromId(tabItems: NonNullable<TabNavigationConfig['tabItems']>, id: HashTabId): number {
    if (!id) {
        return 0;
    }
    const selectedTab = tabItems.findIndex((tab) => tab.cId === id);
    return selectedTab === -1 ? 0 : selectedTab;
}
